import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { AddTutorDto, TutorProfile, UpdateTutorTableDto } from "src/app/_models/Tutor";
import { UpdateStatusDto } from "src/app/_models/UpdateStatusDto";
import { Userprofile } from "src/app/_models/Userprofile";
import { TutorActionTypes } from "src/app/constants/StoreConstants";

export const AddTutor = createAction(
  TutorActionTypes.AddTutor,
  props<{ addTutorDto: AddTutorDto }>()
);

export const AddTutorSuccess = createAction(
  TutorActionTypes.AddTutorSuccess,
  props<{ result: Userprofile }>()
);

export const AddTutorError = createAction(
  TutorActionTypes.AddTutorError,
  props<{ crudTutorError: HttpErrorResponse }>()
);

export const ResetTutorState = createAction(TutorActionTypes.ResetTutorState);

export const GetTutorTable = createAction(
  TutorActionTypes.GetTutorTable,
  props<{ pageNumber: number; isInitialLoad: boolean }>()
);

export const GetTutorTableSuccess = createAction(
  TutorActionTypes.GetTutorTableSuccess,
  props<{ result: TutorProfile[] }>()
);

export const GetTutorTableError = createAction(
  TutorActionTypes.GetTutorTableError,
  props<{ tutorTableError: HttpErrorResponse }>()
);

export const GetTutorTableLength = createAction(
  TutorActionTypes.GetTutorTableLength
);

export const GetTutorTableLengthSuccess = createAction(
  TutorActionTypes.GetTutorTableLengthSuccess,
  props<{ length: number }>()
);

export const GetTutorTableLengthError = createAction(
  TutorActionTypes.GetTutorTableLengthError,
  props<{ error: any }>()
);

export const UpdateTutorTable = createAction(
  TutorActionTypes.UpdateTutorTable,
  props<{ params: UpdateTutorTableDto }>()
);

export const UpdateTutorTableError = createAction(
  TutorActionTypes.UpdateTutorTableError,
  props<{ error: any }>()
);

export const ResetTutorTable = createAction(
  TutorActionTypes.ResetTutorTable,
  props<{ isInitialLoad: boolean }>()
);

export const ResetTutorTableSuccess = createAction(
  TutorActionTypes.ResetTutorTableSuccess,
  props<{ isInitialLoad: boolean }>()
);

export const ResetTutorTableError = createAction(
  TutorActionTypes.ResetTutorTableError,
  props<{ error: any }>()
);

export const ResetTutorCrud = createAction(
  TutorActionTypes.ResetTutorCrud
);

export const GetTutorUserProfile = createAction(
  TutorActionTypes.GetTutorUserProfile,
  props<{ userProfileId: number }>()
);

export const GetTutorUserProfileSuccess = createAction(
  TutorActionTypes.GetTutorUserProfileSuccess,
  props<{ tutorProfile: Userprofile }>(),
);

export const GetTutorUserProfileError = createAction(
  TutorActionTypes.GetTutorUserProfileError,
  props<{ error: HttpErrorResponse }>(),
);

export const UpdateTutorGroupTable = createAction(
  TutorActionTypes.UpdateTutorGroupTable,
  props<{params: UpdateTutorTableDto}>()
);

export const GetGroupTutorCount = createAction(
  TutorActionTypes.GetGroupTutorCount
);

export const GetGroupTutorCountSuccess = createAction(
  TutorActionTypes.GetGroupTutorCountSuccess,
  props<{ result: string }>()
);

export const GetGroupTutorCountError = createAction(
  TutorActionTypes.GetGroupTutorCountError,
  props<{ error: HttpErrorResponse }>()
);

export const TutorHasAccessToLearner = createAction(
  TutorActionTypes.TutorHasAccessToLearner,
  props<{ learnerId: number }>()
);

export const TutorHasAccessToLearnerSuccess = createAction(
  TutorActionTypes.TutorHasAccessToLearnerSuccess,
  props<{ result: boolean }>()
);

export const TutorHasAccessToLearnerError = createAction(
  TutorActionTypes.TutorHasAccessToLearnerError,
  props<{ error: any }>()
);

export const GetCurrentPageNumber = createAction(
  TutorActionTypes.GetCurrentPageNumber,
  props<{ pageIndex: number }>()
);

export const GetCurrentPageNumberSuccess = createAction(
  TutorActionTypes.GetCurrentPageNumberSuccess,
  props<{ currentPageNumber: number }>()
);

export const GetCurrentPageNumberError = createAction(
  TutorActionTypes.GetCurrentPageNumberError,
  props<{ error: any }>()
);

export const UpdateTutorAccountStatus = createAction(
  TutorActionTypes.UpdateTutorAccountStatus,
  props<{ param: UpdateStatusDto[] }>()
);

export const UpdateTutorAccountStatusSuccess = createAction(
  TutorActionTypes.UpdateTutorAccountStatusSuccess,
  props<{ isTutorAccountStatusUpdateSuccessful: boolean }>()
);

export const UpdateTutorAccountStatusError = createAction(
  TutorActionTypes.UpdateTutorAccountStatusError,
  props<{ error: any }>()
);

export const ResetUpdateTutorAccountStatusProps = createAction(
  TutorActionTypes.ResetUpdateTutorAccountStatusProps
)